import { CommonMessages } from '../common.messages';

export const AddEditProductPriceMessages = {
    AddPriceFailed: {
        key: 'AddPriceFailed',
        message: 'Error while request to the server. Unable to register product prices.'
    },
    AddPriceFailedDuplicate: {
        key: 'AddPriceFailedDuplicate',
        message: 'A price already exists for this date. To change it, please edit the current one.'
    },
    AddPriceSucceed: {
        key: 'AddPriceSucceed',
        message: 'Product prices are successfully created.'
    },
    EditPriceFailed: {
        key: 'EditPriceFailed',
        message: 'Error while request to the server. Unable to update product prices.'
    },
    EditPriceSucceed: {
        key: 'AddEditSucceed',
        message: 'Product prices are successfully updated.'
    },
    ...CommonMessages
};
